export default {
  order: {
    title: "Analyse commandes",
    orderStats: "Statistiques commandes",
    orderCount: "Nombre de commandes",
    orderTotalAmount: "Montant total",
    validOrderCount: "Commandes valides",
    totalAmount: "Montant total",
    cancelRightsOrders: "Annulations / litiges",
    shopPushCount: "Envois marchands",
    validOrders: "Commandes valides",
    cancelRights: "Annulations / litiges",
    shopPush: "Envois marchands",
    overview: "Aperçu commandes",
    pendingAccept: "En attente d'acceptation",
    pendingPickup: "En attente de collecte",
    pendingDelivery: "En attente de livraison",
    completed: "Terminées",
    cancelOrder: "Commandes annulées",
    afterSales: "SAV / litiges",
    riderBoard: "Tableau livreurs",
    rankingBoard: "Classements",
    merchantPushTop10: "TOP 10 envois marchands",
    riderAcceptTop10: "TOP 10 commandes livreurs",
    riderAcceptCount: "Livreurs actifs",
    totalRiderCount: "Total livreurs",
    yesterdayFullDay: "Hier (journée)",
    yesterday: "Hier",
    rank: "Rang",
    merchantName: "Marchand",
    pushCount: "Envois",
    orderAmount: "Montant total",
    riderName: "Livreur",
    acceptCount: "Commandes acceptées",
    commission: "Commission",
    totalDistance: "Distance totale",
    top10: "TOP 10",
    chartOrderCount: "Commandes",
    chartOrderAmount: "Montant total",
    chartRiderAccept: "Livreurs actifs",
    chartTotalRider: "Total livreurs",
    chartStackTotal: "Total",
    tipValidOrders: "Commandes non annulées et non remboursées sur la période",
    tipTotalAmount: "Somme des montants de commandes et recharges marchands sur la période",
    tipCancelRights: "Annulations / litiges non traités sur la période",
    tipShopPush: "Nombre d'envois marchands sur la période",
    tipPendingAccept: "Commandes en attente d'acceptation par un livreur",
    tipPendingPickup: "Commandes collectées, en attente de livraison",
    tipPendingDelivery: "Commandes acceptées, en attente de livraison",
    tipCompleted: "Commandes livrées avec succès sur la période",
    tipCancelOrder: "Commandes annulées par le livreur sur la période",
    tipAfterSales: "Demandes SAV / litiges non traitées sur la période",
    tipRiderAccept: "Livreurs ayant accepté au moins une commande aujourd'hui",
    tipTotalRider: "Livreurs certifiés sur la période",
    tipMerchantTop10: "Classement des envois marchands sur la période",
    tipRiderTop10: "Classement des commandes acceptées par livreur sur la période",
  },
  rider: {
    title: "Analyse livreurs",
    pendingReview: "À valider",
    pendingReviewCount: "Livreurs à valider",
    accepted: "Acceptées",
    acceptedRiderCount: "Livreurs en service",
    totalRider: "Total livreurs",
    totalRiderCount: "Total livreurs",
    totalRegistered: "Inscriptions",
    totalRegisterCount: "Total inscriptions",
    onlineStats: "Livreurs en ligne",
    date: "Date",
    onlineRiderCount: "Livreurs en ligne",
    orderCount: "Commandes",
    chartNewRider: "Nouveaux livreurs",
    chartNewRegister: "Nouvelles inscriptions",
    chartStackTotal: "Total",
  },
};
